<template>
    <div>
        <div v-if="showSpinner" class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div v-else-if="outstandingTasks && outstandingTasks.length > 0">
            <b-form-group>
                <b-form-checkbox v-for="task in outstandingTasks"
                                 v-model="selected"
                                 :key="task.taskTypeLabelId"
                                 :value="task.taskTypeId">
                    {{ task.taskTypeLabel }}
                </b-form-checkbox>
            </b-form-group>
            <div class="row mb-2">
                <div class="col">
                    <div class="float-right">
                        <button type="button"
                                class="btn btn-primary"
                                @click="setTasksAsComplete()">
                            Set As Complete
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <p>Currently no outstanding tasks!</p>
        </div>
    </div>
</template>
<script>
    import { repairOptionApiService } from '@/services/repairOption-api.service'
    import moment from "moment";

    export default {
        name: 'SettlementOptionOutstandingTasks',
        props: {
            optionId: { required: true }
        },
        data: () => {
            return {
                loading: true,
                outstandingTasks: [],
                selected: []
            }
        },
        computed: {
            showSpinner() {
                if (this.outstandingTasks.length == 0 && this.loading == true) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            async getOutstandingTasks(id) {
                try {
                    repairOptionApiService
                        .getSettlementOptionOutstandingTasks(id)
                        .then(response => {
                            let { data } = response.data;
                            if (data && data.length > 0) {
                                this.outstandingTasks = data;
                            }
                            this.loading = false;
                        })
                        .catch(err => {
                            console.log("getOutstandingTasks: ", err);
                        });
                } catch (err) {
                    this.loading = false;
                }
            },
            setTasksAsComplete() {
                if (this.selected && this.selected.length > 0) {
                    this.loading = true
                    try {
                        repairOptionApiService
                            .setSettlementOptionTasksComplete({ settlementOptionId: this.optionId, taskIds: this.selected })
                            .then(response => {
                                this.selected = []
                                let { data } = response.data
                                //if (data && data.length > 0) {
                                    this.outstandingTasks = data
                                    this.loading = false
                                //} else {
                                //    this.selected = []
                                //    this.getOutstandingTasks(this.optionId)
                                //}
                            })
                            .catch( async err => {
                                console.log("setTasksComplete: ", err);
                                this.selected = []
                            })
                    } catch (err) {
                        console.error(err)
                        this.loading = false;
                        this.selected = []
                    }
                }
                
            }
        },
        mounted() {
            this.getOutstandingTasks(this.optionId);
        },
    }
</script>